/* eslint-disable no-undef */
import { thunk } from "redux-thunk";
import { createStore, applyMiddleware, combineReducers, compose } from "redux";
import Cookie from "js-cookie";

import usersReducer from "./users/reducer";
import stylesReducer from "./styles/reducer";
import campaignsReducer from "./campaigns/reducer";
import contactsReducer from "./contacts/reducer";
import languageReducer from "./langauge/reducer";
import groupsReducer from "./groups/reducer";
import activitiesReducer from "./activities/reducer";
import reportsReducer from "./reports/reducer";
import payCycleReducer from "./payCycle/reducer";
import paymentReducer from "./payment/reducer";
import browserReducer from "./browser/reducer";

const composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const rootReducer = combineReducers({
  user: usersReducer,
  styles: stylesReducer,
  campaigns: campaignsReducer,
  contacts: contactsReducer,
  language: languageReducer,
  groups: groupsReducer,
  activities: activitiesReducer,
  reports: reportsReducer,
  payCycle: payCycleReducer,
  payment: paymentReducer, // we dont need this but will keep it for now
  browser: browserReducer,
});

const userInfo = Cookie.getJSON("userInfo");

const initialState = {
  user: {
    userInfo,
    conversations: [], // should be changed if it is stored in the Cookei or localStorage
  },
};

const store = createStore(rootReducer, initialState, composeEnhancer(applyMiddleware(thunk)));

export default store;
